import { useEffect, useState } from "react";

import { getSyncDossierTransactionsStatus } from "../../api/dossier/getSyncDossierTransactionsStatus";
import { syncDossierTransactions } from "../../api/dossier/syncDossierTransactions";
import CatchELoadingButton from "./CatchELoadingButton";

const SyncDossierTransactionsButton = ({
  dossierId,
  dateFrom,
  dateTo,
}: {
  dossierId: string;
  dateFrom: string;
  dateTo: string;
}) => {
  const [isSyncing, setIsSyncing] = useState<boolean>(false);
  const { mutateAsync: mutateSyncDossierTransactionsAsync } =
    syncDossierTransactions();

  const syncDossierTransactionsStatus = getSyncDossierTransactionsStatus(
    dossierId,
    {
      mutationOptions: {
        successAlertMessage: isSyncing
          ? "Dossier transactions have synced successfully."
          : undefined,
        errorAlertMessage: isSyncing
          ? "Dossier transactions sync failed"
          : undefined,
      },
    }
  );

  useEffect(() => {
    if (syncDossierTransactionsStatus.isSuccess) {
      if (!isSyncing && syncDossierTransactionsStatus.data === "SYNCING") {
        // Sync was triggered
        setIsSyncing(true);
      } else if (
        isSyncing &&
        syncDossierTransactionsStatus.data !== "SYNCING"
      ) {
        // Sync was finished
        setIsSyncing(false);
      }
    }
  }, [syncDossierTransactionsStatus]);

  const onDossierTransactionsSync = async () => {
    mutateSyncDossierTransactionsAsync({
      dossierId: dossierId,
      dateFrom: dateFrom,
      dateTo: dateTo,
    });
  };

  return (
    <>
      {syncDossierTransactionsStatus.isSuccess && (
        <CatchELoadingButton
          isLoading={isSyncing}
          onClick={onDossierTransactionsSync}
        />
      )}
    </>
  );
};

export default SyncDossierTransactionsButton;
